import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricSearchAbsoluteTopImpressionShare extends MetricBase {
    constructor() {
        super({
            field: "metric_search_absolute_top_impression_share",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.searchAbsoluteTopImpressionShare.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.searchAbsoluteTopImpressionShare.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.searchAbsoluteTopImpressionShare.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricSearchAbsoluteTopImpressionShare;
